/** Local Simple Icons (and related) used on tunnel skill cards. */
export const SKILL_LOGO: Record<string, string> = {
  LangChain: '/icons/tech/langchain.svg',
  LangGraph: '/icons/tech/lucide-workflow.svg',
  RAG: '/icons/tech/lucide-search.svg',
  MCP: '/icons/tech/lucide-network.svg',
  Ollama: '/icons/tech/ollama.svg',
  n8n: '/icons/tech/n8n.svg',
  OpenAI: '/icons/tech/openai.svg',
  'Vector DB': '/icons/tech/vector-db.svg',
  Azure: '/icons/tech/microsoftazure.svg',
  AWS: '/icons/tech/aws.svg',
  Docker: '/icons/tech/docker.svg',
  Kubernetes: '/icons/tech/kubernetes.svg',
  'CI/CD': '/icons/tech/lucide-git-pull-request.svg',
  'GitHub Actions': '/icons/tech/githubactions.svg',
  React: '/icons/tech/react.svg',
  'Next.js': '/icons/tech/nextdotjs.svg',
  TypeScript: '/icons/tech/typescript.svg',
  Tailwind: '/icons/tech/tailwindcss.svg',
  Redux: '/icons/tech/redux.svg',
  'Responsive UI': '/icons/tech/responsive-ui.svg',
  XGBoost: '/icons/tech/lucide-trending-up.svg',
  'Scikit-learn': '/icons/tech/scikitlearn.svg',
  SHAP: '/icons/tech/lucide-chart-pie.svg',
  'Feature Engineering': '/icons/tech/lucide-sliders-horizontal.svg',
  'Model Evaluation': '/icons/tech/lucide-circle-check.svg',
  'Predictive Models': '/icons/tech/lucide-chart-line.svg',
  'Three.js': '/icons/tech/threedotjs.svg',
  R3F: '/icons/tech/r3f.svg',
  Drei: '/icons/tech/drei.svg',
  GSAP: '/icons/tech/gsap.svg',
  GLSL: '/icons/tech/opengl.svg',
  Rapier: '/icons/tech/rapier.svg',
  'Node.js': '/icons/tech/nodedotjs.svg',
  Express: '/icons/tech/express.svg',
  Django: '/icons/tech/django.svg',
  FastAPI: '/icons/tech/fastapi.svg',
  Judge0: '/icons/tech/judge0.svg',
  REST: '/icons/tech/postman.svg',
  GraphQL: '/icons/tech/graphql.svg',
  MongoDB: '/icons/tech/mongodb.svg',
  MySQL: '/icons/tech/mysql.svg',
  Redis: '/icons/tech/redis.svg',
  Qdrant: '/icons/tech/qdrant.svg',
  'Semantic Search': '/icons/tech/semantic-search.svg',
  Microservices: '/icons/tech/lucide-boxes.svg',
  Scalability: '/icons/tech/lucide-trending-up.svg',
  'API Design': '/icons/tech/lucide-plug.svg',
  Concurrency: '/icons/tech/lucide-git-merge.svg',
  Optimization: '/icons/tech/lucide-gauge.svg',
  SDLC: '/icons/tech/lucide-repeat.svg',
};

/** Rasterize local SVGs with a real size so canvas drawImage actually shows them. */
export function loadSkillLogo(src: string): Promise<HTMLImageElement | null> {
  if (!src) return Promise.resolve(null);

  return fetch(src)
    .then((res) => (res.ok ? res.text() : Promise.reject()))
    .then(
      (raw) =>
        new Promise<HTMLImageElement | null>((resolve) => {
          let svg = raw;
          if (!/\swidth=/i.test(svg.slice(0, 280))) {
            svg = svg.replace('<svg', '<svg width="128" height="128"');
          }
          if (!/\sfill=/i.test(svg.slice(0, 280))) {
            svg = svg.replace('<svg', '<svg fill="#1a1814"');
          }
          svg = svg.replace(/stroke="currentColor"/g, 'stroke="#1a1814"');
          const blob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });
          const url = URL.createObjectURL(blob);
          const img = new Image();
          img.onload = () => {
            URL.revokeObjectURL(url);
            resolve(img);
          };
          img.onerror = () => {
            URL.revokeObjectURL(url);
            resolve(null);
          };
          img.src = url;
        }),
    )
    .catch(() => null);
}
